<template>
  <div v-if="isPayment" class="lad-exchange-rate_container-payment">
    <span class="amount">{{
      $t(`${base}.amount_usd`, { amount: amountUsdCurrency })
    }}</span>
    <div v-if="showUsdPrice" class="lad-exchange-rate">
      <p v-if="showAmountUsd" class="price-usd"
        >{{ payment.amount | ladFnCurrency(payment.currency) }}&nbsp;{{
          _currency
        }}</p
      >
      <p v-if="showExchangeRate" class="exchange-rate-usd">{{
        $t(`${base}.exchange_rate_payment`, {
          amount: currentRateCurrency,
        })
      }}</p>
    </div>
  </div>
  <div v-else>
    <div v-if="showUsdPrice" class="lad-exchange-rate">
      <el-divider v-if="withDivision" />

      <p v-if="showAmountUsd" class="price-usd">{{
        $t(`${base}.amount_usd`, { amount: amountUsdCurrency })
      }}</p>
      <p v-if="showExchangeRate" class="exchange-rate-usd">{{
        $t(`${base}.exchange_rate`, { amount: currentRateCurrency, currency })
      }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadExchangeRate',
  props: {
    amount: { type: Object, required: true },
    currency: { type: String, required: true },
    rate: { type: Number, required: false, default: 0 },
    // eslint-disable-next-line vue/no-boolean-default
    showAmountUsd: { type: Boolean, default: true },
    // eslint-disable-next-line vue/no-boolean-default
    showExchangeRate: { type: Boolean, default: true },
    withDivision: { type: Boolean, default: false },
    precision: { type: Number, default: 2 },
    isPayment: { type: Boolean, default: false },
    payment: { type: Object, required: false, default: () => ({}) },
  },
  data() {
    return {
      base: 'experience.price',
    }
  },
  computed: {
    ...mapState('settings', {
      exchangeRate: 'exchange_rate',
      _currency: (state) => state.currency,
    }),
    currentRate() {
      const exchange = this.exchangeRate.find((t) => t.code === this.currency)
      const value = this.rate > 0 ? this.rate : exchange ? exchange.rate : 0

      return this.$options.filters.ladFnPrecision(value)
    },
    currentRateCurrency() {
      const value = this.showUsdPrice
        ? this.currentRate
        : this.$options.filters.ladFnPrecision(1)

      return this.$options.filters.ladFnCurrency(
        value.value > 1 ? value.value : 1 / value.value,
        this.currency,
        true,
        '$',
        this.precision
      )
    },
    showUsdPrice() {
      return this.currentRate.value !== 0 && this.currentRate.value !== 1
    },
    amountUsdCurrency() {
      let value = this.$options.filters.ladFnPrecision(this.amount)

      if (this.currentRate.value > 0) {
        value =
          this.currentRate.value < 1
            ? value.multiply(this.currentRate)
            : value.divide(this.currentRate)
      }

      // const truncate = (Math.trunc(value * 100) / 100).toFixed(2)
      return this.$options.filters.ladFnCurrency(value, this.currency)
    },
  },
}
</script>

<style lang="scss">
.lad-exchange-rate {
  text-transform: capitalize;

  .price-usd {
    font-weight: bold;
    margin: 0;
    font-size: 0.8rem;
  }

  .exchange-rate-usd {
    margin: 0 0 10px;
    font-style: italic;
    font-size: 0.8rem;
  }

  .el-divider--horizontal {
    margin: 10px 0;
  }
}

.lad-exchange-rate_container-payment {
  .price-usd {
    font-weight: 400;
    font-size: 16px;
    color: #221f20;
  }

  .exchange-rate-usd {
    margin: 0 0 10px;
    font-weight: 400;
    font-style: normal;
    font-size: 12.8px;
    color: #5c5c5b;
  }
}
</style>
